import React, { useEffect, useState } from "react";
import { Row, Col, Button, Image, Badge } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import Modal from "react-bootstrap/Modal";
import Form from 'react-bootstrap/Form';
import Element from '../InputFields/input';
import { FormContext } from '../InputFields/FormContext';
import './workflowModals.css';
import Scheduler from '../Scheduler/scheduler'
import Accordion from 'react-bootstrap/Accordion';

function listToDict(list, idGen) {
    let dict = {}
    list.forEach((element) => {
        const dictKey = idGen(element)
        dict[dictKey] = element
    })
    return dict
}

export default function IntelligenceWorkflowModal(props) {
    // console.log("INTELLIGENCE PROPS: ", props)
    const sourceVendors = props.recommendation.workflow.SourceVendors
    const sourceVendorsDict = listToDict(sourceVendors, (item) => item.FlowOrder)
    const targetVendors = props.recommendation.workflow.TargetVendors
    const targetVendorsDict = listToDict(targetVendors, (item) => item.FlowOrder)
    const fullModal = props.fullmodal
    const workflowid = props.recommendation.workflow.FlowId
    const workflowname = props.recommendation.workflow.FlowName
    const reportFormSchema = props.recommendation.workflow.FormSchema.ReportSchema
    const featureFormSchema = props.recommendation.workflow.FormSchema.FeatureSchema
    const [reportFullSchema, setReportFullSchema] = useState(reportFormSchema)
    const [featureFullSchema, setFeatureFullSchema] = useState(featureFormSchema)
    const [elements, setElements] = useState(reportFullSchema);
    const [elements2, setElements2] = useState(featureFullSchema);
    const [schedulerSchema, setScheduleCheck] = useState(props.recommendation.workflow.FormSchema.schedule)
    const [schedulerFormcontext, setSchedulerFormcontext] = useState([])
    const [scheduleModal, setScheduleModal] = useState(false)
    const [buttonClickedState, setButtonClickedState] = useState(false)

    const handleSubmit = (event) => {
        if (!buttonClickedState) {
            event.preventDefault();
            props.handleworkflowsave(workflowid, workflowname, elements2, elements, schedulerSchema, schedulerFormcontext)
            setButtonClickedState(!buttonClickedState)
        } else {
            alert("Workflow is being saved, please wait.")
        }
    }
    const getScheduler = (value) => {
        setSchedulerFormcontext(value)
    }
    const showScheduleModal = () => {
        console.log()
        setScheduleModal(!scheduleModal)
    }

    const handleChange = (field_id, event) => {
        const newElements = [...elements]
        newElements.forEach(field => {
            const { type, id } = field;
            if (field_id === id) {
                switch (type) {
                    case 'checkbox':
                        field['value'] = event.target.checked;
                        break;

                    case 'select':
                        field['value'] = event.value;
                        break;

                    case 'date':
                        field['value'] = event;
                        break;

                    default:
                        field['value'] = event.target.value;
                        break;
                }
            }
            // console.log("NEW ELEMENTS on CHANGE: ", newElements)
            const newFullSchema = [...newElements]
            // console.log("NEW FULL SCHEMA: ", newFullSchema)
            setElements(newFullSchema)
        });

        const newElements2 = [...elements2]
        newElements2.forEach(field => {
            const { type, id } = field;
            if (field_id === id) {
                switch (type) {
                    case 'checkbox':
                        field['value'] = event.target.checked;
                        break;

                    case 'select':
                        field['value'] = event.value;
                        break;

                    case 'date':
                        field['value'] = event;
                        break;

                    default:
                        field['value'] = event.target.value;
                        break;
                }
            }
            // console.log("NEW ELEMENTS on CHANGE: ", newElements2)
            const newFullSchema2 = [...newElements2]
            // console.log("NEW FULL SCHEMA: ", newFullSchema2)
            setElements2(newFullSchema2)
        });

    }

    const VendorRenderer = (props) => {
        return (
            <Row>
                <div className="workflow-modal-logo">
                    <Image src={props.vendor.VendorLogoLink} className="recommended-vendor-logo" rounded />
                    <div className="workflow-name">
                        <h6>{props.vendor.VendorName}</h6>
                    </div>
                </div>
            </Row>
        )
    }

    const FlowAnimationRenderer = (props) => {
        const vendorCount = sourceVendors.length;
        // console.log("FLOW ORDER: ", props.vendor.FlowOrder)
        let classname = "";
        if (props.vendor.FlowOrder == 1) {
            classname = "rainbow intel-tbl";
        } else if (props.vendor.FlowOrder > 1 && props.vendor.FlowOrder < vendorCount) {
            classname = "rainbow intel-line";
        } else {
            classname = "rainbow3 intel-ltr";
        }

        return (
            <Row className="flow-container">
                <Row className="flow-wrapper">
                    <Col md={6} className={classname}></Col>
                </Row>
            </Row>
        )
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            centered
            className={fullModal ? "workflow-modal" : "smallmodal"}
        >
            <Modal.Header closeButton className="modal-header-title">
                {
                    fullModal
                        ?
                        <>
                            <h2>{props.recommendation.workflow.FlowName}</h2>
                            <h6>{props.recommendation.workflow.FlowDescription}</h6>
                        </>
                        :
                        <h6>{props.recommendation.workflow.FlowName}</h6>
                }
            </Modal.Header>
            <Modal.Body className="workflow-modal-body">
                {
                    fullModal ?
                        <Row className="body-layer">
                            <Col md={2} className={sourceVendors.length == 1 ? "flex-column-center-center" : "flex-column-space-center"}>
                                {
                                    sourceVendors && sourceVendors.map(source => (
                                        <VendorRenderer
                                            vendor={sourceVendorsDict[source.FlowOrder]}
                                            key={source.FlowOrder}
                                        />
                                    )
                                    )}
                            </Col>
                            <Col md={1} className={sourceVendors.length == 1 ? "flex-column-center-center" : "flex-column-space-center"}>
                                {sourceVendors && sourceVendors.map((source, index) => (
                                    <FlowAnimationRenderer
                                        vendor={sourceVendorsDict[source.FlowOrder]}
                                        key={source.FlowOrder}
                                    />
                                )
                                )}
                            </Col>
                            <Col md={3} className="flex-column-center-center">
                                <Row className="intel-workflow-action-container-wrapper">
                                    <div className="intel-workflow-action-container">
                                        <Row className="action-input-row">
                                            <h5 className="intelligence-workflow-modal-headings">Select reports</h5>
                                            <FormContext.Provider value={{ handleChange }}>
                                                <Form>
                                                    <Row>
                                                        {
                                                            elements &&
                                                            elements.map((field, i) =>
                                                                <Element
                                                                    key={i}
                                                                    field={field}
                                                                    md={12}
                                                                />)
                                                        }
                                                    </Row>
                                                </Form>
                                            </FormContext.Provider>
                                        </Row>
                                    </div>
                                </Row>
                            </Col>
                            <Col md={1} className="flex-column-center-center">
                                <div className="rainbow intel-anime-line"></div>
                            </Col>
                            <Col md={1} className="cai-dashboard-icon flex-column-center-center">
                                {targetVendors && targetVendors.map(target => (
                                    <VendorRenderer
                                        vendor={targetVendorsDict[target.FlowOrder]}
                                        key={target.FlowOrder}
                                    />
                                ))}
                            </Col>
                            <Col md={1} className="flex-column-center-center">
                                <div className="rainbow intel-anime-line"></div>
                            </Col>
                            <Col md={2} className="flex-column-center-center">
                                <div className="intel-workflow-action-container-2">

                                    <FormContext.Provider value={{ handleChange }}>
                                        <Form>
                                            <Row>
                                                <h5 className="intelligence-workflow-modal-headings">Additional output extensions</h5>
                                                {
                                                    elements2 &&
                                                    elements2.map((field, i) =>
                                                        <Element
                                                            key={i}
                                                            field={field}
                                                            md={12}
                                                        />)
                                                }
                                            </Row>
                                        </Form>
                                    </FormContext.Provider>
                                </div>
                            </Col>
                            <Col md={1} className="flex-column-center-start">
                                {
                                    <div className="flex-row-center-start" style={{ marginTop: 20, fontWeight: 600 }}>
                                        <p>Would you like to schedule this flow? </p>
                                        <input type="checkbox"
                                            className={"form-check-input move-left custom-check-input"} id="exampleCheck2"
                                            checked={schedulerSchema}
                                            onChange={event => setScheduleCheck(event.target.checked)}
                                            autoComplete="new-password"
                                        />
                                    </div>
                                }
                                <div>
                                    <Button type="submit" className="schedule-workflow-button move-right" onClick={(e) => showScheduleModal(!scheduleModal)}>Schedule</Button>
                                    <div className={scheduleModal ? "schedule-holder" : "schedule-holder hidden-scheduler"}>
                                        {
                                            schedulerSchema ?
                                                <Row className="no-gutter pad-trbl-10">
                                                    <Scheduler getscheduler={getScheduler} />
                                                </Row>
                                                : <></>
                                        }
                                    </div>
                                </div>
                                <Button type="submit" className="intel-workflow-save-button move-right" onClick={(e) => handleSubmit(e)}>Submit</Button>
                            </Col>
                        </Row>
                        :
                        <>
                            <Row className="no-gutter">
                                <h5 className="intelligence-workflow-modal-headings">Select reports</h5>
                                <FormContext.Provider value={{ handleChange }}>
                                    <Form>
                                        <Row className="no-gutter">
                                            {
                                                elements &&
                                                elements.map((field, i) =>
                                                    <Element
                                                        key={i}
                                                        field={field}
                                                        md={12}
                                                    />)
                                            }
                                        </Row>
                                    </Form>
                                </FormContext.Provider>
                                <br />
                                <p>   </p>
                                <br />
                                <h5 className="intelligence-workflow-modal-headings">Additional output extensions</h5>
                                <FormContext.Provider value={{ handleChange }}>
                                    <Form>
                                        <Row className="no-gutter">
                                            {
                                                elements2 &&
                                                elements2.map((field, i) =>
                                                    <Element
                                                        key={i}
                                                        field={field}
                                                        md={12}
                                                    />)
                                            }
                                        </Row>

                                        {
                                            <div className="flex-row-center-start" style={{ marginTop: 20, fontWeight: 600 }}>
                                                <p>Would you like to schedule this flow? </p>
                                                <input type="checkbox"
                                                    className={"form-check-input move-left custom-check-input"} id="exampleCheck2"
                                                    checked={schedulerSchema}
                                                    onChange={event => setScheduleCheck(event.target.checked)}
                                                    autoComplete="new-password"
                                                />
                                            </div>
                                        }
                                        {
                                            schedulerSchema ?
                                                <Row className="no-gutter pad-trbl-10">
                                                    <h5>Schedule</h5>
                                                    <Scheduler getscheduler={getScheduler} />
                                                </Row>
                                                : <></>
                                        }

                                        <Row>
                                            <Col md={10}></Col>
                                            <Col md={2} className="no-pad">
                                                <Button type="submit" className="workflow-save-button move-right" onClick={(e) => handleSubmit(e)}>Submit</Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </FormContext.Provider>
                            </Row>
                        </>
                }
            </Modal.Body>
            <Modal.Footer className="workflow-footer">
            </Modal.Footer>
        </Modal>
    );
}